import React, { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Rotas } from 'routes/rotas'
import useSidebarStore from 'store/useSidebar'

type PopupContextProps = {
  popup: { isOpen: boolean; content: string | null }
  showPopup: (content: string) => void
  hidePopup: () => void
}

const PopupContext = createContext<PopupContextProps | undefined>(undefined)
type PopupProviderProps = {
  children: React.ReactNode
}

export const PopupProvider = ({ children }: PopupProviderProps) => {
  const location = useLocation()
  const currentPath = location.pathname
  const { activeSidebar } = useSidebarStore((state) => state)

  const [popup, setPopup] = useState<{ isOpen: boolean; content: string | null }>({
    isOpen: false,
    content: null
  })
  const showPopup = (content: string) => setPopup({ isOpen: true, content })
  const hidePopup = () => setPopup({ isOpen: false, content: null })

  useEffect(() => {
    const routeConfig = popupConfig[currentPath]

    if (routeConfig) {
      showPopup(routeConfig.content)
    }
  }, [currentPath])

  useEffect(() => {
    const isMaterial = activeSidebar === 'menu-support'
    if (isMaterial) {
      showPopup(popupConfig.MATERIAL_APOIO.content)
    }
  }, [activeSidebar])

  return (
    <PopupContext.Provider value={{ popup, showPopup, hidePopup }}>
      {children}
    </PopupContext.Provider>
  )
}

export const usePopup = () => {
  const context = useContext(PopupContext)
  if (context === undefined) {
    throw new Error('usePopup must be used within a PopupProvider')
  }
  return context
}

const popupConfig = {
  [Rotas.INICIO]: {
    content: 'SI'
  },
  [Rotas.DASHBOARD_MANAGEMENT]: {
    content: 'GV'
  },
  [Rotas.FLEXIBILIZACAO]: {
    content: 'FL'
  },
  [Rotas.DOCUMENTACAO]: {
    content: 'DO'
  },
  MATERIAL_APOIO: {
    content: 'MA'
  }
}
